// Single timing origin — performance.now() counts from the browser's navigationStart,
// so logs cover JS parse time too (not just post-boot runtime)
export const logTiming = (label: string) => {
    const t = performance.now().toFixed(0).padStart(5, ' ')
    console.log(`[timing ${t}ms] ${label}`)
}
